import {
  LANGUAGE_GROUP_DANISH,
  LANGUAGE_GROUP_ENGLISH,
  LANGUAGE_GROUP_FRENCH,
  LANGUAGE_GROUP_GERMAN
} from "@/common/language-groups";
import { addPackageAndLangParams } from "@/common/route-path-helpers";
import { MatomoHelper } from "@/helpers";
import { i18n } from "@/i18n";
import { useSettingsStore } from "@/stores";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

const WorkshopNav = {
  /**
   * @returns {boolean}
   */
  isVisible() {
    const settingsStore = useSettingsStore();

    return [
      LANGUAGE_GROUP_DANISH,
      LANGUAGE_GROUP_ENGLISH,
      LANGUAGE_GROUP_GERMAN,
      LANGUAGE_GROUP_FRENCH
    ].includes(settingsStore.activeLanguageGroup);
  },

  /**
   * @typedef {import("vue-router").RouteLocationRaw} RawLocation
   *
   * @typedef {{
   *  id: string,
   *  type: string,
   *  icon: string,
   *  title: string,
   *  visible: () => boolean,
   *  action: () => RawLocation,
   *  click: () => any
   * }} NavItem
   *
   * @returns {NavItem[]}
   */
  getItems() {
    const settingsStore = useSettingsStore();

    return [
      {
        id: "irregular-verbs",
        type: "link",
        icon: "IconIrregular",
        title: `${i18n.global.t("menu.workshopItems.irregularVerbs")}`,
        visible() {
          return [LANGUAGE_GROUP_ENGLISH, LANGUAGE_GROUP_GERMAN, LANGUAGE_GROUP_FRENCH].includes(
            settingsStore.activeLanguageGroup
          );
        },
        action() {
          return addPackageAndLangParams({ name: "workshop.irregular-verbs" });
        },
        click() {
          return MatomoHelper.sendEvent(
            MatomoEventCategory.AbcWorkshop,
            MatomoEventAction.ClickIrregularVerbs,
            "Clicked Irregular Verbs topbar"
          );
        }
      },
      {
        id: "conjugation",
        type: "link",
        icon: "IconWorkshopDocument",
        title: `${i18n.global.t("menu.workshopItems.conjugation")}`,
        visible() {
          return [LANGUAGE_GROUP_GERMAN].includes(settingsStore.activeLanguageGroup);
        },
        action() {
          return addPackageAndLangParams({ name: "workshop.inflection-trainer" });
        },
        click() {
          return MatomoHelper.sendEvent(
            MatomoEventCategory.AbcWorkshop,
            MatomoEventAction.ClickInflectionTool,
            "Clicked Inflection tool topbar"
          );
        }
      },
      {
        id: "workshop.dsn-spelling-rules",
        type: "link",
        icon: "IconSpelling",
        title: `${i18n.global.t("menu.workshopItems.rules")}`,
        visible() {
          return settingsStore.activeLanguageGroup === LANGUAGE_GROUP_DANISH;
        },
        action() {
          return addPackageAndLangParams({ name: "workshop.dsn-spelling-rules" });
        },
        click() {
          return MatomoHelper.sendEvent(
            MatomoEventCategory.AbcWorkshop,
            MatomoEventAction.ClickSpellingRules,
            "Clicked Spelling Rules topbar"
          );
        }
      }
    ];
  }
};

export default WorkshopNav;
